export type FilterItemServerProps = {
  filterTitle: string;
  hideAccordion?: boolean;
};

export const SHOW_FILTERS = 7;
